import { UserContextProvider } from "./../module/user/user-context";
import { MenuContextProvider } from "./../module/portal/menu-context";
import { JobMonitoringContextProvider } from "./../module/job-monitoring/job-monitoring-context";
import { ExecutionPlanContextProvider } from "./../module/job-execution-plan/job-execution-plan-context";
import { CriteriaContextProvider } from "./../module/job-execution-plan/criteria-context";
export default function MainProvider({ children }) {
  return (
    <UserContextProvider>
      <MenuContextProvider>
        <JobMonitoringContextProvider>
          <ExecutionPlanContextProvider>
            <CriteriaContextProvider>{children}</CriteriaContextProvider>
          </ExecutionPlanContextProvider>
        </JobMonitoringContextProvider>
      </MenuContextProvider>
    </UserContextProvider>
  );
}
